import { useState, useEffect } from 'react';
import mqtt from 'mqtt';

import { HTTPError, Plant, Reading, ControllerEvent } from '../../../src/types';
import plantService from '../services/plant'


const usePlant = (id:string) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [plant, setPlant] = useState<Plant>();
    const [readings, setReadings] = useState<Reading[]>([])
    const [latestReading, setLatestReading] = useState<Reading>();
    const [events, setEvents] = useState<ControllerEvent[]>([]);
    
    const fetchReadings = async(hours:number) => {
        try {
            const newReadings:Reading[] = await plantService.getPlantReadings(id, hours);
            setReadings(newReadings);
        }
        catch(e) {
            setError((e as HTTPError).response.data['error'])
        }
    };

    const fetchEvents = async(hours:number) => {
        try {
            const newEvents:ControllerEvent[] = await plantService.getPlantEvents(id, hours);
            setEvents(newEvents);
        }
        catch(e) {
            setError((e as HTTPError).response.data['error'])
        }
    };

    useEffect(() => {
        // TODO: provide this via settings/configuration
        const client = mqtt.connect('ws://miel-nuble:9091');
        const fetchPlant = async() => {
            try {
                const plantData:Plant = await plantService.getPlant(id);
                setPlant(plantData);
                const plant_descriptor = plantData.name.replaceAll(' ', '_')
                const plant_topic = `reactor/sensor/${plant_descriptor}`;
                client.on('connect', () => {
                    console.log('connected');
                    client.subscribe(plant_topic);
                })
                client.on('message', (topic, message) => {
                    console.log(topic, message.toString());
                    if (topic == plant_topic){
                        const update = JSON.parse(message.toString());
                        const newReading:Reading = {
                            rawValue:update['sensor_value'],
                            moisture:update['moisture_level'],
                            createdAt:update['sample_time']*1000,
                            plant: plantData,
                            id:'0'
                        }
                        setLatestReading(newReading);
                    }
                })

            }
            catch(e) {
                setError((e as HTTPError).response.data['error'])
            }
            finally {
                setLoading(false);
            }
        };
        setLoading(true)
        fetchPlant();
        fetchReadings(24);
        fetchEvents(24)
    }, [setPlant, id]);

    useEffect(() => {
        if (latestReading && readings.length > 0){
            setReadings([...readings, latestReading])
        }
    }, [latestReading]);

    return {plant, setPlant, readings, fetchReadings, events, fetchEvents, loading, error};
};

export default usePlant;